import { GetterTree } from 'vuex';
import { Store } from '@/store/types';
import { Snack, SnackbarState } from '../types';

export const snackbarGetters: GetterTree<SnackbarState, Store> = {

  firstSnackInQueue(state): Snack | undefined {
    return state.snackQueue[0];
  },

  snackQueueLength(state): number {
    return state.snackQueue.length;
  },

};
